export default "__VITE_ASSET__D1UB5Xql__"